import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {sendPost, setTokenToStorage} from "api/restUtil"
import { URL } from "pages/menu";
import { isEmpty } from "js/common";

function Login(props) {
    const navigate = useNavigate();

    const [userInfo, setUserInfo] = useState({ loginId: "", loginPw: "" });
    const inputRef = useRef({});
	const LOGIN_ID_SAVE_KEY = "SFF_LOGIN_ID_SAVE_KEY";

	useEffect(() => {
		const loginId = localStorage.getItem(LOGIN_ID_SAVE_KEY);
		if(!isEmpty(loginId)) {
			// 저장된 ID 있는 경우
			inputRef.current.saveLoginId.checked = true;	// 체크박스 체크
			setUserInfo({ ...userInfo, loginId: loginId });	// loginId 설정
			inputRef.current.loginPw.focus();				// 비밀번호 입력 칸에 focus
		} else {
			// 저장된 ID 없는 경우
			inputRef.current.loginId.focus();	// loginId 입력 칸에 focus
		}
	}, []);

    const submitFormHandler = (e) => {
        //로그인
        e.preventDefault();

		const loginUrl = "/api/login"
		sendPost(loginUrl, userInfo)
		.then(result=> {
			if(result?.respCode === "SUCCESS" || result?.respCode === "CHANGE_LOGIN_PW") {
				// 성공 또는 비밀번호 변경 필요. 비밀번호 변경 필요는 Alert은 뜨지만, 이후 정상 로그인과 동일한 프로세스 수행.
				saveLoginId();	// ID 저장
				setTokenToStorage(result.data.accessToken, result.data.refreshToken);	// 토큰 저장
				navigate(URL.MAIN)	// 메인페이지로 이동
			}
		})
    };

	// ID 저장
	const saveLoginId = () => {
		if(inputRef.current.saveLoginId.checked) {
			// 체크 되어 있으면 저장
			localStorage.setItem(LOGIN_ID_SAVE_KEY, userInfo.loginId);
		} else {
			// 체크 안 되어 있으면 삭제
			localStorage.removeItem(LOGIN_ID_SAVE_KEY);
		}
	}

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            submitFormHandler(e);
        }
    };

    const handleIdChange = (e) => {
        const value = e.target.value.replace(/[ \t\n\r]+/g, ''); // 입력값에서 공백 제거
        setUserInfo({ ...userInfo, loginId: value });
    };
    
    const handlePasswordChange = (e) => {
        const value = e.target.value.replace(/[ \t\n\r]+/g, ''); // 입력값에서 공백 제거
        setUserInfo({ ...userInfo, loginPw: value });
    };

	const handleSaveIdChanged = (e) => {
		// ID 저장 체크박스 해제시 저장된 ID 제거
		if(!e.target.checked) {
			localStorage.removeItem(LOGIN_ID_SAVE_KEY);
		}
	}

    return (
		<div className="egov-container">
			<div className="c_wrap">
				<div className="layout">

					<div className="contents" id="contents">
						{/* <!-- 본문 --> */}
						<div className="Plogin mg-t-20">
							<h1>로그인</h1>

							<div className="login_box" style={{ backgroundColor: "white" }}>
								<form name="" method="" action="">
									<fieldset>
										<legend>로그인</legend>
										<span className="group">
											<input
												ref={el => inputRef.current.loginId = el}
												type="text"
												name=""
												title="아이디"
												placeholder="아이디"
												value={userInfo?.loginId}
												onChange={handleIdChange}
												onKeyDown={handleKeyPress}
											/>
											<input
												ref={el => inputRef.current.loginPw = el}
												type="password"
												name=""
												title="비밀번호"
												placeholder="비밀번호"
												onChange={handlePasswordChange}
												onKeyDown={handleKeyPress}
											/>
										</span>
										
										<div className="idSaveCheckBox">
											<input type="checkbox" id={"saveId"} ref={el => inputRef.current.saveLoginId = el} onChange={handleSaveIdChanged} />
											<label htmlFor={"saveId"} className="mg-l-5">ID저장</label>
										</div>

										<button type="button" onClick={submitFormHandler}>
											<span>LOGIN</span>
										</button>
									</fieldset>
								</form>
							</div>

							<ul className="list">
								<li>비밀번호는 6~12자의 영문 대/소문자, 숫자, 특수문자를 2가지 이상 혼합해서 사용하실 수 있습니다.</li>
								<li>쉬운 비밀번호나 자주 쓰는 사이트의 비밀번호가 같을 경우, 도용되기 쉬우므로 주기적으로 변경하셔서 사용하는 것이 좋습니다.</li>
							</ul>
						</div>
						{/* <!--// 본문 --> */}
					</div>
				</div>
			</div>
		</div>
    );
}

export default Login;
